import { cn } from '@shared/cove-ui';
import { LogoPrimary } from '@shared/react-ui-core';
import { ImageType } from '@website/components/seo';
import { useTranslation } from 'react-i18next';

type CoveNavLogoProps = {
  // When provided, partnerImage will display a partners logo next to the Cove logo in the nav.
  // see https://www.covesmart.com/lifemart/ for an example
  partnerImage?: Omit<ImageType, 'id' | 'title'> | null;
};

const CoveNavLogo = ({ partnerImage }: CoveNavLogoProps): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <div className="ml-cove-5 flex w-max flex-col items-start justify-center px-0 py-cove-15">
      <a href="/" className="flex items-center">
        <div
          className={cn(
            'px-0 py-cove-5 leading-none',
            partnerImage && 'flex items-center border-r border-r-cove-green',
          )}
        >
          <LogoPrimary width={91} className="-translate-x-[3px]" />
          <span className="sr-only">Go back to covesmart.com homepage</span>
        </div>
        {partnerImage?.url && partnerImage?.alt && (
          <img
            src={partnerImage.url}
            alt={partnerImage.alt ?? ''}
            className="h-full w-auto"
          />
        )}
      </a>
      <span className="m-0 inline-block p-0 text-sm leading-snug text-cove-navy-blue sm:hidden">
        {t('try-it-for-60-days-risk-free', {
          defaultValue: 'Try it for 60 days risk-free',
        })}
      </span>
    </div>
  );
};

export default CoveNavLogo;
